// NO EDITAR A MANO
export type Langs = "ca" | "cs" | "da" | "de" | "de-AT" | "en" | "en-GB" | "en-US" | "es" | "eu" | "fi" | "fr" | "gl" | "hi" | "hu" | "it" | "nl" | "no" | "pl" | "pt" | "pt-BR" | "ro" | "ru" | "sk" | "sv" | "tr";

export default ["ca", "cs", "da", "de", "de-AT", "en", "en-GB", "en-US", "es", "eu", "fi", "fr", "gl", "hi", "hu", "it", "nl", "no", "pl", "pt", "pt-BR", "ro", "ru", "sk", "sv", "tr"];
